var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "34px",
    viewBox: "0 0 30 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-finaliseplan-doc-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17_Complete-Plan---Inactive",
    transform: "translate(-669.000000, -541.000000)",
    fill: "#77777A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(490.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.000000, 24.000000)",
    id: "ic-finaliseplan-doc-inactive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(4.999500, 3.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4383333,0 C26.765,0 29.95,3.2 30,8.55333333 L30,24.6516667 C30,30.08 26.8066667,33.3333333 21.4383333,33.3333333 L8.56333333,33.3333333 C7.87666667,33.3333333 7.225,33.28 6.61166667,33.175 L6.24833333,33.1066667 C2.29666667,32.285 0,29.2583333 0,24.6516667 L0,8.68166667 C0,8.125 0.0333333333,7.59166667 0.1,7.08166667 C0.681666667,2.60666667 3.75666667,0 8.56333333,0 L21.4383333,0 Z M21.4233333,2.42833333 L8.56333333,2.42833333 C4.47,2.42833333 2.395,4.53333333 2.395,8.68166667 L2.395,24.6516667 C2.395,28.8 4.47,30.905 8.56333333,30.905 L21.4233333,30.905 C25.515,30.905 27.5766667,28.8 27.5766667,24.6516667 L27.5766667,8.68166667 C27.5766667,4.53333333 25.515,2.42833333 21.4233333,2.42833333 Z M20.9883333,22.5166667 C21.645,22.5166667 22.1766667,23.0566667 22.1766667,23.7233333 C22.1766667,24.39 21.645,24.93 20.9883333,24.93 L8.97,24.93 C8.31333333,24.93 7.78,24.39 7.78,23.7233333 C7.78,23.0566667 8.31333333,22.5166667 8.97,22.5166667 L20.9883333,22.5166667 Z M20.9883333,15.4516667 C21.4466667,15.4016667 21.895,15.6216667 22.14,16.0166667 C22.385,16.415 22.385,16.9183333 22.14,17.3166667 C21.895,17.7116667 21.4466667,17.9316667 20.9883333,17.8816667 L8.97,17.8816667 C8.36,17.8116667 7.89833333,17.29 7.89833333,16.6666667 C7.89833333,16.0433333 8.36,15.52 8.97,15.4516667 L20.9883333,15.4516667 Z M13.5566667,8.40333333 C14.1666667,8.47166667 14.6283333,8.995 14.6283333,9.61833333 C14.6283333,10.24 14.1666667,10.7633333 13.5566667,10.8316667 L8.985,10.8316667 C8.37333333,10.7633333 7.91166667,10.24 7.91166667,9.61833333 C7.91166667,8.995 8.37333333,8.47166667 8.985,8.40333333 L13.5566667,8.40333333 Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPreviewIcon);
export default __webpack_public_path__ + "static/media/doc-preview-icon.91710df0150188e2c7e2b42005208a84.svg";
export { ForwardRef as ReactComponent };